import { compose } from 'redux'
import { connect } from 'react-redux'
import { usersTodayArray } from 'selectors'

export default compose(
  connect(state => ({
    usersTodayArray: usersTodayArray(state),
  }))
)



// WEBPACK FOOTER //
// ./src/components/Map/Map.enhancer.js